module.exports = __webpack_public_path__ + "static/media/mentor-matcher-preview.ff54761b.png";